import { RouteRecordRaw } from 'vue-router'
import Home from '@/views/home/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    name: 'home',
    component: Home,
  },
  {
    path: 'products',
    name: 'products',
    component: () => import('../products/Products.vue'),
  },
  {
    path: 'vision',
    name: 'vision',
    component: () => import('../vision/Vision.vue'),
  },
  {
    path: 'team',
    name: 'team',
    component: () => import('../team/Team.vue'),
  },
]

export default routes
